<template>
  <div class="mtnpay-warp">
    <div class="mtnpay-dot"></div>
    <div class="mtnpay-title">{{ i18n.mtn_mobile_number }}</div>
    <div class="mtnpay-row">
      <div class="area" @click="isAreaView = true">
        <span>+{{ areaCode }}</span>
        <div class="area-down"></div>
      </div>
      <input type="number" v-model="phone" :placeholder="i18n.mtn_mobile_number" />
    </div>
    <div class="mtnpay-btn">
      <div class="btn" @click="onSubmit">{{ i18n.submit }}</div>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { SelectArea } from "@/components/select"
import areaCodes from '@/utils/area_code.js'
export default {
  components: {
    SelectArea
  },
  computed: {
    ...mapState(["user"]),
    i18n() {
      return this.$t("confirm")
    }
  },
  data() {
    return {
      isAreaView: false,
      areaCode: '250',
      phone: ''
    }
  },
  methods: {
    onSelct(val) {
      this.areaCode = val
    },
    onSubmit() {
      if (!this.phone) {
        this.$toast(this.i18n.mtn_mobile_number_tips)
        return
      }
      this.$emit('change', `${this.areaCode}${this.phone}`)
    },
    phoneNumberParser() {
      try {
        let phoneNumber = this.user.pmobile
        if (!phoneNumber) {
          this.areaCode = '250'
          this.phone = ''
          return
        }
        for (let i = 0; i < areaCodes.length; i++) {
          let dialCode = areaCodes[i].value;
          if (phoneNumber.startsWith(dialCode)) {
            let nationalNumber = phoneNumber.substring(dialCode.length);
            this.areaCode = dialCode
            this.phone = nationalNumber
            return
          }
        }
      } catch (e) {
        this.areaCode = '250'
        this.phone = ''
      }
    }
  },
  created() {
    this.phoneNumberParser()
  }
}
</script>

<style lang="less" scoped>
.mtnpay-warp {
  background: #FFFFFF;
  border-radius: 68px 68px 0px 0px;
  padding: 30px 53px 110px;
  .mtnpay-dot {
    width: 100px;
    height: 8px;
    border-radius: 4px;
    background-color: #D5D5D5;
    margin: 0 auto;
  }
  .mtnpay-title {
    font-size: 35px;
    font-weight: bold;
    padding: 66px 0 48px;
  }
  .mtnpay-row {
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 4px solid #D5D5D5;
    border-radius: 10px;
    padding: 0 20px;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }

    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: #000 transparent transparent;
    }

    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );
      margin-right: 20px;

      img {
        width: 180px;
        height: 60px;
      }
    }
  }
  .mtnpay-btn {
    margin-top: 60px;
  }
}
</style>
